var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDailyCry(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 23.2372C18.6274 23.2372 24 18.0353 24 11.6186C24 5.20181 18.6274 0 12 0C5.37258 0 0 5.20181 0 11.6186C0 18.0353 5.37258 23.2372 12 23.2372Z",
    fill: "#FF9240"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.0919 14.2284C15.9122 14.2284 16.5771 13.5846 16.5771 12.7904C16.5771 11.9962 15.9122 11.3523 15.0919 11.3523C14.2716 11.3523 13.6066 11.9962 13.6066 12.7904C13.6066 13.5846 14.2716 14.2284 15.0919 14.2284Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.90811 14.2284C9.72839 14.2284 10.3934 13.5846 10.3934 12.7904C10.3934 11.9962 9.72839 11.3523 8.90811 11.3523C8.08782 11.3523 7.42285 11.9962 7.42285 12.7904C7.42285 13.5846 8.08782 14.2284 8.90811 14.2284Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M7.51075 7.96437C8.29246 7.61117 8.66001 7.23406 8.96584 6.89745C9.14206 6.70359 9.39167 6.79256 9.38961 7.06875C9.38481 7.66561 9.00424 8.47625 7.97978 8.93901C6.95532 9.40109 6.06938 9.16275 5.59418 8.78232C5.37406 8.60638 5.46389 8.36339 5.73132 8.35741C6.19418 8.34745 6.72904 8.31691 7.51075 7.96437Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M16.4892 7.96437C15.7075 7.61117 15.34 7.23406 15.0341 6.89745C14.8579 6.70359 14.6083 6.79256 14.6104 7.06875C14.6152 7.66561 14.9957 8.47625 16.0202 8.93901C17.0447 9.40109 17.9306 9.16275 18.4058 8.78232C18.6259 8.60638 18.5361 8.36339 18.2687 8.35741C17.8058 8.34745 17.2709 8.31691 16.4892 7.96437Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M4.84192 12.5268C4.84192 12.5268 2.9082 14.5352 2.9082 16.1551C2.9082 17.1889 3.77426 18.0247 4.84192 18.0254C5.90957 18.0254 6.77563 17.1889 6.77563 16.1551C6.77563 14.5352 4.84192 12.5268 4.84192 12.5268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M15.9064 18.8374H8.0927C7.7135 18.8374 7.40698 18.5399 7.40698 18.1734C7.40698 17.807 7.7135 17.5095 8.0927 17.5095H15.9064C16.2856 17.5095 16.5921 17.807 16.5921 18.1734C16.5921 18.5399 16.2856 18.8374 15.9064 18.8374Z",
    fill: "#A02424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M8.79419 21.0057C8.79419 22.6595 10.2212 24 11.9814 24C13.7416 24 15.1686 22.6595 15.1686 21.0057L15.2063 17.5095H8.8319L8.79419 21.0057Z",
    fill: "#F5172B"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailyCry);
export default __webpack_public_path__ + "static/media/daily_cry.f7fe0cbd920265061ea1cc523abe2f5d.svg";
export { ForwardRef as ReactComponent };